module.exports = __webpack_public_path__ + "static/img/9.9ec7107.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/99/zh/9.png
// module id = oaRC
// module chunks = 0